import React from 'react';

import { Formik, FieldArray } from 'formik';
import Input from './form/FormikInput';
import { ListInputBox, ListInputItem } from './form/FormikListInputBox';
import { providerSchema } from '../pages/ProvidersAdd';
import Checkbox from '../components/form/Checkbox';

const ProviderForm = ({ initalValues = {}, onSubmit = () => {}, onCancel = () => {}, success = null }) => {
    const showVendorValidationErrors = (errors) => {
        if (errors) {
            if (typeof errors === 'string') {
                return errors;
            }

            if (errors instanceof Array) {
                return errors.map((err, i) => {
                    if (err) {
                        return (
                            <div key={`err_${i}`}>
                                {err.royaltyrecordid && <div>{err.royaltyrecordid}</div>}
                                {err.findawayvendorid && <div>{err.findawayvendorid}</div>}
                                {err.spotify_licensor_id && <div>{err.spotify_licensor_id}</div>}
                            </div>
                        );
                    }
                    return null;
                });
            }
        }
    };

    return (
        <Formik initialValues={initalValues} validationSchema={providerSchema} onSubmit={onSubmit}>
            {({
                dirty,
                values,
                touched,
                errors,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                resetForm,
                setFieldValue,
                setFieldTouched
            }) => {
                return (
                    <form
                        className="col-sm-12"
                        onSubmit={handleSubmit}
                        onReset={() => resetForm(initalValues)}
                        noValidate
                    >
                        <Input
                            id="name"
                            label="Name"
                            labelClass="font-weight-bold"
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            errors={errors.name}
                            touched={!!touched.name}
                            required
                        />

                        <ListInputBox
                            id="publishers"
                            label="Publishers"
                            labelClass="font-weight-bold"
                            placeholder="Publisher Name"
                            value={values.publishers}
                            onChange={(values) => setFieldValue('publishers', values)}
                            onBlur={setFieldTouched}
                            errors={errors.publishers}
                            touched={!!touched.publishers}
                        >
                            {({ removeItem, items }) => (
                                <ul className="list-group">
                                    {items.map((item, index) => (
                                        <ListInputItem key={item} index={index} onRemove={removeItem}>
                                            {item}
                                        </ListInputItem>
                                    ))}
                                </ul>
                            )}
                        </ListInputBox>

                        <div className="label-wrapper">
                            <label htmlFor="singletitleupload" className="font-weight-bold">
                                Edit Access
                            </label>
                        </div>
                        <div className="mb-2">
                            <small className="font-italic">
                                If this is un-checked, all users associated with this provider will be able to use
                                Passport Single Title Upload. User-level permissions may override this selection.
                            </small>
                        </div>
                        <Checkbox
                            label="Read Only"
                            id="singletitleupload"
                            checked={!values.singletitleupload}
                            onChange={(id, val) => {
                                setFieldValue('singletitleupload', !val);
                            }}
                        />

                        <div className="label-wrapper">
                            <label htmlFor="vendors" className="required font-weight-bold">
                                Vendors{' '}
                                <small className="text-muted font-weight-normal font-italic text-danger">
                                    (required)
                                </small>
                            </label>
                        </div>
                        <FieldArray name="vendors">
                            {(arrayHelpers) => (
                                <div className="mb-5">
                                    {values.vendors.map((vendor, index) => (
                                        <>
                                            <div className="row mb-3 bottom-xs" key={index}>
                                                {vendor?.vendorname && (
                                                    <div className="col-xs-12 col-md-2">
                                                        <div className="form-group mb-0">
                                                            <div className="label-wrapper">
                                                                <label>Name</label>
                                                            </div>
                                                            <div className="flex-vertical-align">
                                                                {vendor.vendorname}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                <div className="col-xs-12 col-md-2">
                                                    <Input
                                                        id={`vendors.${index}.findawayvendorid`}
                                                        name={`vendors.${index}.findawayvendorid`}
                                                        label="NetSuite Vendor ID"
                                                        value={vendor.findawayvendorid || ''}
                                                        onChange={handleChange}
                                                        collapse
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-md-2">
                                                    <Input
                                                        id={`vendors.${index}.tipaltipayeeid`}
                                                        name={`vendors.${index}.tipaltipayeeid`}
                                                        label="Tipalti ID"
                                                        value={vendor.tipaltipayeeid || ''}
                                                        onChange={handleChange}
                                                        collapse
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-md-2">
                                                    <Input
                                                        id={`vendors.${index}.royaltyrecordid`}
                                                        name={`vendors.${index}.royaltyrecordid`}
                                                        label="Royalty Record ID"
                                                        value={vendor.royaltyrecordid || ''}
                                                        onChange={handleChange}
                                                        collapse
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-md-3">
                                                    <Input
                                                        id={`vendors.${index}.spotify_licensor_id`}
                                                        name={`vendors.${index}.spotify_licensor_id`}
                                                        label="Spotify Licensor ID"
                                                        value={vendor.spotify_licensor_id || ''}
                                                        onChange={handleChange}
                                                        collapse
                                                    />
                                                </div>
                                                <div className="col-xs">
                                                    <button
                                                        className="btn btn-sm btn-danger"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            if (
                                                                window.confirm(
                                                                    'Are you sure you want to remove this vendor? Clicking the Save button will finalize this removal.'
                                                                )
                                                            ) {
                                                                arrayHelpers.remove(index);
                                                            }
                                                        }}
                                                    >
                                                        Remove
                                                    </button>
                                                </div>
                                            </div>
                                        </>
                                    ))}
                                    <button
                                        className="btn btn-sm"
                                        type="button"
                                        onClick={() =>
                                            arrayHelpers.push({
                                                findawayvendorid: '',
                                                tipaltipayeeid: '',
                                                royaltyrecordid: '',
                                                spotify_licensor_id: ''
                                            })
                                        }
                                    >
                                        Add Vendor
                                    </button>
                                    {errors.vendors && touched.vendors && (
                                        <div className="form-error standalone mt-2">
                                            {showVendorValidationErrors(errors?.vendors)}
                                        </div>
                                    )}
                                </div>
                            )}
                        </FieldArray>

                        <button className="btn btn-sm btn-primary" type="submit" disabled={isSubmitting}>
                            Save
                        </button>
                        <button className="btn btn-sm" type="reset" disabled={isSubmitting} onClick={onCancel}>
                            Reset
                        </button>
                    </form>
                );
            }}
        </Formik>
    );
};

export default ProviderForm;
